import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <AssessmentIcon sx={{ fontSize: 32, mr: 2, color: 'white' }} />
          <Typography variant="h6" color="white">
            {title}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
